<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import Icon from "./Icon.vue";
import { remaining } from "../api/mappers";
import { eventWhen } from "../composables/eventDetails";
import { vTooltip } from "../directives/tooltip";
import { t } from "../i18n";

/**
 * Beside the window's clock: the conversation concludes later unless the contact answers first
 * ("Conclui em 23 h · Sem resposta"), with its × to call it off.
 */
const props = defineProps<{
  at: string;
  outcome: string;
  canCancel?: boolean;
}>();
const emit = defineEmits<{ cancel: [] }>();
const now = ref(new Date());
let timer: ReturnType<typeof setInterval> | undefined;
onMounted(() => {
  timer = setInterval(() => (now.value = new Date()), 30_000);
});
onBeforeUnmount(() => clearInterval(timer));
const left = computed(
  () => remaining(props.at, now.value) ?? t("time.minutes", { n: 1 }),
);
</script>
<template>
  <span
    class="window-chip close-chip"
    v-tooltip="
      t('inbox.scheduled_close.tip', {
        outcome,
        when: eventWhen(at),
      })
    "
  >
    <Icon name="checkCircle" :size="14" />
    {{ t("inbox.scheduled_close.chip", { time: left, outcome }) }}
    <button
      v-if="canCancel"
      type="button"
      class="chip-x"
      :aria-label="t('inbox.scheduled_close.cancel')"
      @click="emit('cancel')"
    >
      <Icon name="close" :size="12" />
    </button>
  </span>
</template>
